import { useUrlStateV2 } from 'hooks';
import { useMemo } from 'react';

export function useSuggestionModal() {
  const [{ suggestionId }, setParams] = useUrlStateV2({
    suggestionId: '',
  });

  return useMemo(
    () => ({
      openSuggestion: (id: string) => setParams({ suggestionId: id }),

      closeSuggestion: () => setParams({ suggestionId: null }),

      suggestionId,
    }),
    [suggestionId, setParams],
  );
}
